<div [ngStyle]="{'width': diameter, 'height': diameter}">
</div>
